import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';

export default class SubOrgsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(params: any = {}): Promise<any> {
    const querystring = this.encodeQueryData(params);
    return super.get(api.get_sub_organisations + '?' + querystring);
  }

  public async create(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.create_sub_organisations, formData);
  }

  public async delete(id: string): Promise<any> {
    return super.delete(api.delete_sub_organisations + '/' + id, {});
  }
  public async update(id: string, data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(api.edit_sub_organisations + '/' + id, formData);
  }

  public async getSubOrgUsers(id: string): Promise<any> {
    const data = { sub_org_id: id };
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_sub_organisation_users + '?' + querystring, {});
  }

  public async deleteUserFromSubOrg(
    sub_org_id: string,
    user_id: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('sub_org_id', sub_org_id);
    formData.append('user_id', user_id);
    return super.delete(api.remove_user_from_sub_organisation, formData);
  }

  public async addUserToSubOrg(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    return super.post(api.add_user_to_sub_organisation, formData);
  }

  public async getSubOrgsWithUsers(): Promise<any> {
    return super.get(api.get_sub_organisations_with_users);
  }
}
